import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';

import type { RouteDraftEndpoint } from '@/stores/RouteWorkspaceContext';

interface EndpointBadgeProps {
  readonly endpoint: RouteDraftEndpoint | null;
}

const LAT_LON_DECIMALS = 5;

export default function EndpointBadge({ endpoint }: EndpointBadgeProps) {
  const { t } = useTranslation();
  if (endpoint === null) {
    return (
      <Tag color="default" style={{ marginTop: 4 }}>
        {t('routes.endpoint.unset')}
      </Tag>
    );
  }
  return (
    <Tag color="success" style={{ marginTop: 4 }}>
      {endpoint.lat.toFixed(LAT_LON_DECIMALS)}, {endpoint.lon.toFixed(LAT_LON_DECIMALS)}
    </Tag>
  );
}
